<template>
    <v-container
        class="pt-0 mt-3"
    >

                <!--------------------------------->
                <!--  Set Outer Component Rules  -->
                <!--------------------------------->
        <v-row
            justify="center"
            align="center"
            class="d-flex flex-nowrap"
        >

                <!--------------------------------->
                <!--      Scroll Left Button     -->
                <!--------------------------------->
            <v-btn
                icon
                color="grey darken-4"
                class="ml-3 mr-1"
                @click.prevent="allergiesScrollLeft"
            >
                <v-icon
                    large
                >
                    mdi-chevron-left
                </v-icon>
            </v-btn>

                <!--------------------------------->
                <!--      Scrollable Section     -->
                <!--------------------------------->
            <v-container
                id="allergies"
                align="center"
                justify="center"
                class="allergies"
            >

                <!--------------------------------->
                <!--       Option Iterator       -->
                <!--------------------------------->
                <v-col
                    v-for="(allergy,a) in allergies"
                    :key="a"
                    flat
                    class="text-no-wrap"
                >
                    <v-card
                        flat
                        width="78"
                        height="95"
                        color="#ffffff"
                    >
                        <v-row
                            justify="center"
                        >
                            <v-avatar
                                v-if="allergy.selected =='true' | allergy.selected"
                                size="84"
                                color="#74cf74"
                                @click.prevent="updateAllergies(a)"
                            >
                                <v-avatar
                                    size="76"
                                >
                                    <img
                                        :src="require('@/assets/allergy/' + allergy.img)"
                                    />
                                </v-avatar>
                            </v-avatar>
                            <v-avatar
                                v-else
                                size="66"
                                color="grey darken-4"
                                @click.prevent="updateAllergies(a)"
                            >
                                <v-avatar
                                    size="62"
                                >
                                    <img
                                        :src="require('@/assets/allergy/' + allergy.img)"
                                    />
                                </v-avatar>
                            </v-avatar>
                        </v-row>
                        <v-row
                            justify="center"
                            class="text-no-wrap"
                        >
                            <div
                                v-if="allergy.selected =='true' | allergy.selected"
                                class="ma-0 pa-0 font-weight-black"
                                style="color: #74cf74;"
                            >
                                {{allergy.name}}
                            </div>
                            <div
                                v-else
                                class="ma-0 pa-0 font-weight-medium"
                            >
                                {{allergy.name}}
                            </div>
                        
                        </v-row>
                    </v-card>
                </v-col>

            </v-container>

                <!--------------------------------->
                <!--     Scroll Right Button     -->
                <!--------------------------------->
            <v-btn
                icon
                color="grey darken-4"
                class="mr-3 ml-1"
                @click.prevent="allergiesScrollRight"
            >
                <v-icon
                    large
                >
                    mdi-chevron-right
                </v-icon>
            </v-btn>

        </v-row>
        <v-row
            justify="center"
        >

        </v-row>

    </v-container>
</template>


<style scoped>
    .allergies {
        overflow-y: hidden;
        overflow-x: auto;
        display: flex;
        margin: 0px 0px 0px 0px;
        padding: 0px 5px 0px 5px;
    }

    .allergies::-webkit-scrollbar {
        display: none;
    }


</style>

<script>
export default {

    data: () => ({
        
    }),
    
    methods: {
        allergiesScrollLeft: function() {
            document.getElementById('allergies').scrollLeft -= 204
        },
        allergiesScrollRight: function() {
            document.getElementById('allergies').scrollLeft += 204
        },
        updateAllergies: function(value) {
            this.$store.dispatch('data/updateAllergies',value);
            this.$store.dispatch('data/savedPreferences');
        }
    },


    computed: {
        allergies() {
            return this.$store.getters['data/allergies'];
        },    
    } 

};
</script>
